// extracted by mini-css-extract-plugin
export default {"wrapper":"Login_wrapper__6R0Cv"};